import React, { useCallback, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import message from "@/utils/globalMessage";
import { api } from "@/redux/api";
import ContractList from "@/containers/contract/ContractList";

export default function ContractRequestPage() {
  const navigate = useNavigate();
  const location = useLocation();
  const [facilities, setFacilities] = useState([]);
  const [facilityIds, setFacilityIds] = useState([]);

  useEffect(() => {
    api.getContractFacilities()
      .then((facilityResponse) => {
        const facilityRows = facilityResponse.data || [];
        setFacilities(facilityRows);
        const allowedIds = new Set(facilityRows.map((item) => item.id));
        const requestedFacilities = new URLSearchParams(location.search)
          .getAll("facility")
          .map(Number)
          .filter((id) => allowedIds.has(id));
        if (requestedFacilities.length) {
          setFacilityIds(Array.from(new Set(requestedFacilities)));
        } else {
          setFacilityIds(facilityRows.map((item) => item.id));
        }
      })
      .catch(() => message.error("Failed to load facilities"));
  }, [location.search]);

  const changeFacilities = useCallback((nextFacilityIds) => {
    const params = new URLSearchParams();
    nextFacilityIds.forEach((id) => params.append("facility", id));
    setFacilityIds(nextFacilityIds);
    navigate(
      `/contract/contract-request${params.toString() ? `?${params.toString()}` : ""}`,
      { replace: true }
    );
  }, [navigate]);

  const loadRequests = useCallback(
    (selectedFacilityIds, params) => api.getContractRequests(selectedFacilityIds, params),
    []
  );

  const getDetailPath = useCallback(
    (record) => {
      const params = new URLSearchParams();
      facilityIds.forEach((id) => params.append("facility", id));
      return `/contract/contract-request-detail/${record.id}${params.toString() ? `?${params.toString()}` : ""}`;
    },
    [facilityIds]
  );

  return (
    <ContractList
      facilityIds={facilityIds}
      facilities={facilities}
      onFacilityChange={changeFacilities}
      loadRequests={loadRequests}
      getDetailPath={getDetailPath}
      showFacilityColumn
    />
  );
}
